export type ModuleName = "products"
export const MODULE_NAME: ModuleName = "products"

export enum activeProductType {
  ADAPT = "adapt",
  DILL = "dill",
  DILL_CLOUD = "dill_cloud"
}
